import { Column } from 'react-table'
import { columnGenerators } from '../../../../../../_metronic/helpers'
export const header = (isFranchise = false) => [
  {
    label: 'S.N',
    value: 'id',
  },
  {
    label: 'Type',
    value: 'typen',
  },
  {
    label: 'Category',
    value: 'categoryName1',
  },
  {
    label: 'Item',
    value: 'itemName',
  },
  {
    label: 'GROUND STOCK',
    value: 'gsval',
  },
  {
    label: 'In transit',
    value: 'blockedQuantity',
  },
  // {
  //   label: 'Stock',
  //   value: 'pickupPointAddress[country]',
  // },
  {
    label: 'Total Stock',
    value: 'quantity',
  },
  {
    label: 'Unit',
    value: 'unitType',
  },
  // {
  //   label: 'Avg Price',
  //   value: 'totalPrice',
  // },
  // ...((isFranchise && [
  //   {
  //     action: ['view'],
  //   },
  // ]) ||
  //   []),
]

// const roleColumns: ReadonlyArray<Column<any>> = columnGenerators(header)

// export {roleColumns}

const roleColumns = (isFranchise = false) => {
  return columnGenerators(header(isFranchise))
}
export { roleColumns }
